import React, { Fragment } from 'react';
import clsx from 'clsx';
import { Menu, Transition } from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';

export interface AcaoSolicitacao {
  label: string;
  onClick: () => void;
  perigosa?: boolean;
}

/** Menu ⋮ do cabeçalho: as ações menos usadas (copiar link, cancelar/reativar, excluir) saem
 * do rodapé da página e ficam juntas aqui, sem disputar espaço com o trabalho do dia a dia. */
export default function SolicitacaoAcoesMenu({ acoes }: { acoes: AcaoSolicitacao[] }) {
  return (
    <Menu as="div" className="relative">
      <Menu.Button
        aria-label="Mais ações"
        className="flex h-11 w-11 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
      >
        <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-20 mt-1 w-56 rounded-md border border-gray-200 bg-white py-1 shadow-lg focus:outline-none">
          {acoes.map((acao) => (
            <Menu.Item key={acao.label}>
              {({ active }) => (
                <button
                  type="button"
                  onClick={acao.onClick}
                  className={clsx(
                    'block w-full px-4 py-2.5 text-left text-sm',
                    acao.perigosa ? 'text-red-600' : 'text-gray-700',
                    active && (acao.perigosa ? 'bg-red-50' : 'bg-gray-50')
                  )}
                >
                  {acao.label}
                </button>
              )}
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
